module.exports = require("ramda");


//////////////////
// WEBPACK FOOTER
// external "ramda"
// module id = 8
// module chunks = 0